import React from 'react';
import classnames from 'classnames';
import { Card, Button, ShimmerLoader } from '@guildeducationinc/recess';
import ProgramCardList from '@src/components/Shared/ProgramCardList/ProgramCardList';
import ErrorMessage from '@shared/ErrorMessage/ErrorMessage';
import { openCalendly, calendlyLinkWithParams } from '@src/utilities/openCalendly';
import Divider from '@src/components/Shared/Divider/Divider';
import { clickable } from '@src/analytics';
import useGetCoachRecommendations, {
  RecommendationsType,
} from '@src/hooks/useGetCoachRecommendations';
import useGetMemberUser from '@src/hooks/useGetMemberUser';
import { CallCoachAction } from './CallCoachAction';
import './Recommendations.scss';

const Recommendations: React.FC = () => {
  const {
    coachRecommendations,
    message,
    loading: loadingCoachRecs,
    error,
  } = useGetCoachRecommendations();
  const { memberUser, loading: loadingMemberUser } = useGetMemberUser();
  const calendlyUrl = memberUser?.coachingLinks?.growthCoachingLink || '';

  if (error) {
    return <ErrorMessage />;
  }

  const loading = loadingCoachRecs || loadingMemberUser;

  const messageClassNames = classnames('messageClass', 'boxShadow--none');

  const programsArray = coachRecommendations?.map(
    (recommendation: RecommendationsType) => recommendation.program
  );

  return (
    <ShimmerLoader loaded={!loading} label='coach recommendations' height='10rem'>
      <ProgramCardList
        programCardType='recommendations'
        programs={programsArray}
        renderIfEmpty={<CallCoachAction />}
      >
        {message && (
          <Card className={messageClassNames}>
            <Card.Header className='flex flexJustify--space_between flexItems--center'>
              Message from your coach
              <Button
                appearance='ghost'
                disabled={!calendlyUrl}
                onClick={() => {
                  clickable({
                    product: 'home',
                    loggedIn: true,
                    tag: 'learn_skills',
                    text: 'learn_skills_schedule_a_call',
                    type: 'link',
                    external_url: calendlyLinkWithParams(calendlyUrl),
                  });
                  openCalendly(calendlyUrl);
                }}
              >
                Schedule a call
              </Button>
            </Card.Header>

            <div className='padding--bottom_16'>
              <Divider stretch='sm' />
            </div>

            <Card.Content>
              <p>{message.message}</p>
            </Card.Content>
          </Card>
        )}
      </ProgramCardList>
    </ShimmerLoader>
  );
};

export default Recommendations;
